import { render, staticRenderFns } from "./ProjectIssueStatistics.vue?vue&type=template&id=50462acc&scoped=true&"
import script from "./ProjectIssueStatistics.vue?vue&type=script&lang=js&"
export * from "./ProjectIssueStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50462acc",
  null
  
)

export default component.exports